module.exports = __webpack_public_path__ + "img/cn_pocket-3.2dd8531.jpg";